module.exports = __webpack_public_path__ + "img/tiket-discount.3dd5fbcc.png";